import React from 'react';
import { Container } from '@material-ui/core';
import styled from 'styled-components';
import useEagerConnect from '../../hooks/useEagerConnect';

// import Footer from '../Footer';
import Nav from '../Nav';
// import CollectButton from '../CollectButton'

const StyledPage = styled.div`
background-repeat: no-repeat;
background-image: url(/images/ring1.png), url(/images/ring2.png), url(/images/ring3.png);
background-position: left top, right top 100px, left top 250px;
`

const Page: React.FC = ({ children }) => {
  useEagerConnect();
  return (
    <StyledPage>
      <Nav />
      {/* <CollectButton /> */}
      <Container maxWidth="lg" style={{ paddingBottom: '12rem', maxWidth: '1200px' }}>
        {children}
      </Container>
      {/* <Footer /> */}
    </StyledPage>
  );
};

export default Page;
